export default "__VITE_ASSET__C$$6a4Nc__"